export interface IWaitlistAudit {
    recipientCenterId: number,
    recipientCenterAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorAlias: string,
    donorAbo: string,
    swapNumber: string,
    recipientAlias: string,
    offerDate: string,
    decisionDate: string,
    decision: string,
    rejectionReasonText: string,
    rejectionReasonId: number,
    rejectionReason: string,
    rootCauseId: number,
    rootCause: string,
    isAccepted?: boolean | number | null,
    isExcludedFromDeclineRatio?: boolean | number | null,
    declineRatio?: number | string | null,
}